export default "__VITE_ASSET__DO$BUvO7__"